import { useHistory } from 'react-router-dom';

export const useRedirect = () => {
  const history = useHistory();

  return history.push;

}